export const idlFactory = ({ IDL }) => {
  const TransactionItem = IDL.Record({
    'to' : IDL.Text,
    'status' : IDL.Nat8,
    'ethTransferTx' : IDL.Text,
    'from' : IDL.Text,
    'icrcBlockIndex' : IDL.Nat,
    'approveTransferTx' : IDL.Text,
    'timestamp' : IDL.Int,
    'amount' : IDL.Nat,
  });
  return IDL.Service({
    'approve' : IDL.Func([IDL.Nat, IDL.Text, IDL.Text], [IDL.Nat8], []),
    'getLogs' : IDL.Func([IDL.Nat], [IDL.Vec(TransactionItem)], []),
    'getPendingTransactions' : IDL.Func(
        [IDL.Nat],
        [IDL.Vec(TransactionItem)],
        [],
      ),
    'getTransaction' : IDL.Func([], [IDL.Opt(TransactionItem)], []),
    'saveCompletedTx' : IDL.Func([IDL.Text], [IDL.Bool], []),
    'saveTransferTx' : IDL.Func([IDL.Nat, IDL.Text, IDL.Text], [IDL.Bool], []),
    'setPaused' : IDL.Func([IDL.Bool], [], []),
  });
};
export const init = ({ IDL }) => { return []; };
